import { useState } from "react";
import { useUpdateEffect } from "ahooks";
import { useGlobalState } from "@/GlobalProvider";

function CompanyChangeHandleWrapper({ children }) {
  const [rerender, setRerender] = useState(false);
  const { currentCompanyId } = useGlobalState();

  useUpdateEffect(() => {
    setRerender(true);
    Promise.resolve().then(() => {
      setRerender(false);
    });
  }, [currentCompanyId]);

  if (rerender) return null;

  return children;
}

export default CompanyChangeHandleWrapper;
